import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const highRiskApi = {
  getConsent: async (uhid) => {
    const response = await api.get(`/get_consent_high_risk/${uhid}`);
    return response.data;
  },
  
  getPatient: async (uhid) => {
    const response = await api.get(`/get_patient/${uhid}`);
    return response.data;
  },

  getNextIp: async () => {
    const response = await api.get('/highrisk_next_ip');
    return response.data;
  },

  createConsent: async (data) => {
    const response = await api.post('/create_consent_high_risk', data);
    return response.data;
  },

  updateConsent: async (uhid, data) => {
    const response = await api.put(`/update_consent_high_risk/${uhid}`, data);
    return response.data;
  },

  generateShareToken: async (uhid) => {
    const response = await api.post(`/generate_for_medical_highrisk_api_token/${uhid}`);
    return response.data;
  },

  transcribeAudio: async (audioFile) => {
    const formData = new FormData();
    formData.append('audio', audioFile);
    const response = await api.post('/transcribe-audio', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};
